import { RelocationOrderStatus } from "@/api-schema-enums";
import { cn } from "@/common/helpers/utils";
import { Button, ButtonSize, ButtonVariant } from "@/components/ui/button";
import { getStatusColor } from "../_helpers/load-status";

interface StatusButtonProps {
  currentStatus: RelocationOrderStatus;
  onStatusCycle: () => void;
}

export function StatusButton({ currentStatus, onStatusCycle }: StatusButtonProps) {
  return (
    <div className="flex justify-center">
      <Button
        variant={ButtonVariant.Ghost}
        size={ButtonSize.Sm}
        onPointerDown={(e) => {
          e.preventDefault();
          onStatusCycle();
        }}
        className="h-14 w-14 touch-manipulation rounded-full p-0 transition-all duration-200 hover:scale-105"
      >
        <div className={cn(getStatusColor(currentStatus), "h-12 w-12 rounded-full transition-colors duration-200")} />
      </Button>
    </div>
  );
}
